import type { SyncrelState } from "../domain/types";

export const renderSettingsPanel = (state: SyncrelState): string => `
  <section class="utility-dock utility-dock--settings">
    <div class="panel-head">
      <div>
        <h2>Settings & data</h2>
        <span>Workspace files and room portability</span>
      </div>
    </div>
    <div class="utility-body">
      <div class="utility-group utility-group--workspace-file">
        <div>
          <strong>Workspace file</strong>
          <p class="dock-hint">Export the entire current room as a file. Imports never overwrite a room; after selecting a file, choose append or create new workspace.</p>
        </div>
        <button type="button" data-export-workspace>Export workspace file</button>
        <label class="workspace-file-picker">
          <span>Import workspace file</span>
          <input
            type="file"
            data-import-workspace-file
            accept="application/json,.json,.syncrel.json"
            aria-label="Import workspace file"
          />
        </label>
        <div class="workspace-file-summary" aria-label="Current workspace contents">
          <span><b>${state.entities.length}</b> cards</span>
          <span><b>${state.relations.length}</b> links</span>
          <span><b>${state.schema.fields.length}</b> fields</span>
        </div>
      </div>
    </div>
  </section>
`;
